import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { AppConfig } from '../../../app.config';

export interface Tag {
  color: string;
  value: string;
}

export interface ChildrenItem {
  state: string;
  name: string;
  type: 'link' | 'sub' | 'extLink' | 'extTabLink';
  children?: ChildrenItem[];
}

export interface Menu {
  state: string;
  name: string;
  type: 'link' | 'sub' | 'extLink' | 'extTabLink';
  icon: string;
  badge?: Tag;
  children?: ChildrenItem[];
}

export interface NavItem {
  displayName: string;
  disabled?: boolean;
  iconName: string;
  route?: string;
  order: number;
  children?: NavItem[];
}

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  menus$: Observable<Menu[]>;
  public sideNav: any;
  public currentUrl = new BehaviorSubject<string>(undefined);
  apiBaseUrl: string;
  APIEdnpoint: any;

  constructor(
    private http: HttpClient,
    @Inject('BASE_URL') baseUrl: string,
    private router: Router
  ) {
    this.apiBaseUrl = baseUrl;
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl.next(event.urlAfterRedirects);
      }
    });
  }

  GetPages(): Observable<NavItem[]> {
    return this.http.get<NavItem[]>(
      AppConfig.settings.settings.apiEndpoint + 'api/rolepermission/GetPages/'
    );
  }

  GetSubPages(menuName: string): Observable<NavItem[]> {
    return this.http
      .get<NavItem[]>(
        `${AppConfig.settings.settings.apiEndpoint}api/RolePermission/GetSubPagesbyPage/` + menuName
      );
  }

  public closeNav() {
    this.sideNav.close();
  }

  public openNav() {
    this.sideNav.open();
  }
}
